module.exports = __webpack_public_path__ + "static/img/game.3a55d006.svg";